/**
 * PATCH `admin/whatsapp/templates/:id` — название и подписи переменных
 * общего шаблона.
 *
 * Бэк различает «не передали» и «передали пусто»: не передал `title` —
 * поле не трогают, передал `null` — вернётся имя из Meta. Поэтому
 * пустую строку из формы отправляем именно как `null`, иначе названием
 * шаблона стала бы пустая строка.
 *
 * Подписей должно быть ровно столько, сколько у шаблона переменных —
 * это проверяет бэк, и форма обязана прислать полный массив.
 */

import {http} from '@services/utils';

import {toTemplate} from '../toTemplate';
import type {Template, TemplateLabelsInput} from '../types';

export const setTemplateLabels = async ({
  id,
  title,
  variableLabels,
}: TemplateLabelsInput): Promise<Template> => {
  const raw = await http(`admin/whatsapp/templates/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: {title: title?.trim() || null, variableLabels},
    skipCaseConversion: true,
  });
  return toTemplate(raw);
};
